export const GREY_LIGHT = 50;
export const GREY_DARK = 900;
